import React from 'react'
import {
  TouchableOpacity,
  Image,
  ImageSourcePropType,
  ViewStyle,
  View,
  TextStyle,
  Platform,
  ImageStyle,
} from 'react-native'
import { Instance } from 'mobx-state-tree'

import { GetBackgroundColorOfMimeType, useStores } from '@trivie/core'
import { UpNextTileModel } from '@trivie/core/src/models/UpNextTile'

const DEFAULT_BACKDROP = require('../../assets/images/backdrops/default-backdrop.png')
const TEST_BACKDROP = require('../../assets/images/backdrops/test-backdrop.png')
const SURVEY_BACKDROP = require('../../assets/images/backdrops/survey-backdrop.png')
import { ResourceIcon } from '../resource-icon'
import { CountdownTimer } from '../countdown-timer'
import { Text } from '../text'
import { color } from '../../theme'
interface PlayTileProps {
  tile: Instance<typeof UpNextTileModel>
  onPress?: () => void
  locale?: string
  style?: ViewStyle
  index?: number
  imageStyle?: ImageStyle
  titlePadding?: number
  defaultBackdrop?: ImageSourcePropType
  surveyBackdrop?: ImageSourcePropType
  testBackdrop?: ImageSourcePropType
}

export const PlayTile = (props: PlayTileProps) => {
  const {
    titlePadding = 0,
    style,
    index,
    locale,
    onPress,
    tile,
    imageStyle,
    defaultBackdrop = DEFAULT_BACKDROP,
    surveyBackdrop = SURVEY_BACKDROP,
    testBackdrop = TEST_BACKDROP,
  } = props

  if (!tile) {
    return null
  }

  const { userStore } = useStores()
  const isSubscriptionWorkspace = userStore.isSubscriptionWorkspace

  const { object_title, due_date, object_type, extension } = tile

  const renderImage = () => {
    switch (object_type?.toLowerCase()) {
      case 'survey':
        return surveyBackdrop
      case 'assessment':
        return testBackdrop
      default:
        if (tile.topic_image_url || tile.object_image_url) {
          return Platform.OS === 'web'
            ? tile.object_image_url || tile.topic_image_url
            : { uri: tile.object_image_url || tile.topic_image_url }
        }
        return defaultBackdrop
    }
  }

  return (
    <TouchableOpacity
      // @ts-ignore
      dataSet={{ qat: `up_next_tile_${index}` }}
      style={{ ...ROOT, ...style }}
      key={`up_next_tile_${index}`}
      onPress={onPress}
    >
      {due_date && !isSubscriptionWorkspace ? (
        <CountdownTimer locale={locale ?? 'en'} style={TIMER} date={due_date} />
      ) : null}
      {object_type?.toLowerCase() === 'source' ? (
        <View
          style={{
            backgroundColor: GetBackgroundColorOfMimeType(extension ? extension : 'url'),
            ...RESOURCE_ICON,
          }}
        >
          <View style={{ transform: [{ scale: 2 }], alignSelf: 'center' }}>
            <ResourceIcon extension={extension ? extension : 'url'} white={true} />
          </View>
        </View>
      ) : (
        <Image
          source={renderImage()}
          resizeMode="cover"
          style={{
            height: 75,
            width: 238,
            borderTopLeftRadius: 20,
            borderTopRightRadius: 20,
            ...imageStyle,
          }}
        />
      )}
      <View style={CONTENT}>
        <View style={SUBTITLE_CONTAINER}>
          <Text
            numberOfLines={1}
            variant="body2Emphasized"
            uppercase
            align="center"
            style={{ ...SUBTITLE, paddingHorizontal: 20 }}
            tx={tile.subtitleTx}
          />
        </View>
        <View style={TITLE_CONTAINER}>
          <Text
            numberOfLines={2}
            align="center"
            style={{ paddingHorizontal: titlePadding }}
            variant="titleEmphasized"
            text={object_title.trim()}
          />
        </View>
      </View>
    </TouchableOpacity>
  )
}

const ROOT: ViewStyle = {
  padding: 0,
  borderWidth: 1,
  borderColor: '#EFF0F6',
  width: 240,
  height: 171,
  borderRadius: 20,
  minWidth: 240,
  justifyContent: 'center',
  flexDirection: 'column',
  alignItems: 'center',
  backgroundColor: color.white,
}
const SUBTITLE: TextStyle = { color: color.shade50 }
const TIMER: ViewStyle = { position: 'absolute', zIndex: 999, top: 40, right: 8 }
const RESOURCE_ICON: ViewStyle = {
  height: 75,
  width: 238,
  borderTopLeftRadius: 20,
  borderTopRightRadius: 20,
  justifyContent: 'center',
}
const CONTENT: ViewStyle = {
  width: 270,
  paddingTop: 16,
  flex: 1,
  paddingBottom: 16,
}
const SUBTITLE_CONTAINER: ViewStyle = {
  flexDirection: 'column',
  justifyContent: 'flex-start',
  paddingHorizontal: 20,
  marginBottom: 2,
}
const TITLE_CONTAINER: ViewStyle = {
  flexDirection: 'column',
  flex: 1,
  justifyContent: 'center',
  paddingHorizontal: 20,
}
